import React from 'react';
import Modal from '../../modal/Modal';
import { Button } from 'react-bootstrap';

var RemoveItemRewardsConfirmationModal = function RemoveItemRewardsConfirmationModal(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide,
      removeItem = props.removeItem;
  var ContinueButton = model.ContinueButton,
      CancelButton = model.CancelButton,
      Header = model.Header,
      Copy = model.Copy;

  var handleContinue = function handleContinue() {
    removeItem();
    hide();
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--add-remove-item-rewards-confirmation',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-add-remove-item-rewards-confirmation-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-add-remove-item-rewards-confirmation-modal__body-container'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-add-remove-item-rewards-confirmation-modal__body-container__header'
  }, Header === null || Header === void 0 ? void 0 : Header.value), /*#__PURE__*/React.createElement("span", {
    className: 'cb-add-remove-item-rewards-confirmation-modal__body-container__copy'
  }, Copy === null || Copy === void 0 ? void 0 : Copy.value), /*#__PURE__*/React.createElement(Button, {
    className: 'cb-button-primary cb-add-remove-item-rewards-confirmation-modal__body-container__continue-btn',
    onClick: handleContinue
  }, ContinueButton === null || ContinueButton === void 0 ? void 0 : ContinueButton.value), /*#__PURE__*/React.createElement(Button, {
    className: 'cb-button-secondary cb-add-remove-item-rewards-confirmation-modal__body-container__cancel-btn',
    onClick: hide
  }, CancelButton === null || CancelButton === void 0 ? void 0 : CancelButton.value))));
};

export default RemoveItemRewardsConfirmationModal;